import SamBillingAddressRules from '../../components/forms/rules/SamBillingAddressRules'
import SamBillingContactRules from '../../components/forms/rules/SamBillingContactRules'
import SamBillingCustomMailRules from '../../components/forms/rules/SamBillingCustomMailRules'

// Mixin instead of rules was needed for being able to use "this" context
import SamIntraVatRulesMixins from './VatIdentiferValidatorMixins'

export default {
    mixins: [ SamIntraVatRulesMixins ],
    data() {
        return {
            billingContactTmp: {},
            billingContactPhoneTmp: {
                defaultCC: "fr",
                CC: "",
                dialCode: "",
                e164: "",
                e164Formated: "",
            },
            billingAddressTmp: {},
            subscription: {},

            samBillingAddressRules: SamBillingAddressRules,
            samBillingContactRules: SamBillingContactRules,
            additionalEmailRecipientsRules: [
                {
                    type: 'array',
                    required: false,
                    defaultField: {
                        type: 'email',
                        message: Loc.g('Veuillez renseigner uniquement des adresses email valides')
                    }
                },
                {
                    type: 'array',
                    required: false,
                    defaultField: {
                        validator: (rule, value, callback, source, options) => {
                            if (value === this.billingContactTmp.contactEmail) callback(new Error(Loc.g('Veuillez renseigner une adresse email différente de l\'adresse de facturation')));
                            callback();
                        }
                    }
                }
            ]
        }
    },
    computed: {
        country() { return this.getCountryFromCode(this.billingAddressTmp.country) },
        billingAddressHasChanged() { return !_.isEqual(this.billingAddress, this.billingAddressTmp) },
        billingContactHasChanged() {
            let contactProperties = ['contactName', 'contactFirstName', 'contactEmail', 'locale', 'additionalEmailRecipients'];
            return !_.isEqual(_.pick(this.billingSettings, contactProperties), _.pick(this.billingContactTmp, contactProperties)) 
            || this.billingSettings.contactPhone !== this.billingContactPhoneTmp.e164
        },
        billingLocale() { return this.getBillingLocaleFromCode(this.billingContactTmp.locale) },
        isBillingContactValid() { return this.isContactValid(this.billingContactTmp, this.billingContactPhoneTmp) },
        isBillingAddressValid() { return this.isAddressValid(this.billingAddressTmp) },
        isBillingCustomMailValid() { return this.isCustomMailValid(); },
        samBillingAddressAndIntraVatRules() { return { ...this.samBillingAddressRules, ...this.samIntraVatRules} },
        samBillingCustomMailRules() {
            return this.billingCustomMail.contactAdded ? SamBillingCustomMailRules : {};
        }
    },
    methods: {
        updateBilligContactPhoneTmp(phone) { this.billingContactTmp.contactPhone = phone.e164 },
        initBillingContactTmp() {
            this.billingContactTmp = { 
                ...this.billingContact,
                additionalEmailRecipients: this.billingSettings.additionalEmailRecipients?.length ? _.cloneDeep(this.billingSettings.additionalEmailRecipients) : []
            };
            // has contact phone ?
            if (!this.billingContact || !this.billingContact.contactPhone) return;
            // init contactPhone
            if (this.billingContact.contactPhone[0] == '+') this.billingContactPhoneTmp.e164 = this.billingContact.contactPhone;
            else this.billingContactPhoneTmp.dialCode = this.billingContact.contactPhone;
        },
        initBillingAddressTmp() { 
            this.billingAddressTmp = { 
                ...this.billingAddress,
                ...{ vatIdentificationNumber : this.billingSettings.vatIdentificationNumber || '' }
            } 
        },

        // GET
        getPricingVersions() {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/sam-cart/pricing-versions`, {}, (response) => {
                    resolve(response)
                });
            });
        },
        getPricingRevisions(version) {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/sam-cart/pricing-versions/` + version + `/pricing-revisions`, {}, (response) => {
                    resolve(response)
                });
            });
        },
        getPricingRevisionDatas(revision) {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/sam-cart/pricing-revisions/` + revision + `/datas`, {}, (response) => {
                    resolve(response)
                });
            });
        },
        getPricingPlans(revision) {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/sam-cart/pricing-revisions/` + revision + `/plans`, {}, (response) => {
                    resolve(response)
                });
            });
        },
        getPricingProducts(revision) {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/sam-cart/pricing-revisions/` + revision + `/products`, {}, (response) => {
                    resolve(response.map(function (product, index) {
                        product.isSelected = false;
                        product.rank = index +1;
                        return product;
                    }));
                });
            });
        },
        getCustomerDatas(corporation) {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/sellsy-account-manager/corporation/`+corporation+`/datas`, {}, (response) => {
                    resolve(response)
                });
            });
        },
        getCustomer(corporation) {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/sellsy-account-manager/corporation/`+corporation+`/customer`, {}, (response) => {
                    resolve(response)
                });
            });
        },
        getBillingSettings(corporation) {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/sellsy-account-manager/corporation/`+corporation+`/billing-settings`, {}, (response) => {
                    resolve(response)
                });
            });
        },
        getCustomerSettings(corporation) {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/sellsy-account-manager/corporation/`+corporation+`/settings`, {}, (response) => {
                    resolve(response)
                });
            });
        },
        getBillingAddress(corporation) {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/sellsy-account-manager/corporation/`+corporation+`/billing-address`, {}, (response) => {
                    if (response.error !== undefined && response.error.code == 200) resolve(false)
                    resolve(response)
                });
            });
        },
        getAccounts(corporation) {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/sellsy-account-manager/corporation/`+corporation+`/accounts`, {}, (response) => {
                    resolve(response)
                });
            });
        },
        getActiveCreditCard(corporation) {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/sellsy-account-manager/corporation/` + corporation + `/creditcard`, {}, (response) => {
                    resolve(response)
                }, (error) => reject(error.response.data.error));
            });
        },
        getSubscribedProducts(corporation) {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/sellsy-account-manager/corporation/` + corporation + `/subscribed-products`, {}, (response) => {
                    resolve(response)
                });
            });
        },
        getTermsStatus(corporation, type) {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/sellsy-account-manager/corporation/` + corporation + `/terms/`+type, {}, (response) => {
                    resolve(response);
                })
            });
        },
        getUtm(corporation) {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/sellsy-account-manager/corporation/` + corporation + `/utm`, {}, (response) => {
                    resolve(response);
                })
            });
        },
        getCart(corporation, id) {
            return new Promise((resolve) => {
                this.$ajax.get("/rest/sellsy-account-manager/corporation/" + corporation + "/cart/" + id, {}, (response) => {
                    resolve(response)
                });
            });
        },
        getActiveCartByContext(corporation, context) {
            return new Promise((resolve) => {
                this.$ajax.get("/rest/sellsy-account-manager/corporation/" + corporation + "/cart/active/" + context, {}, (response) => {
                    resolve(response)
                });
            });
        },
        // PUT
        recordBillingContact(corporation, billingContact, billingContactPhone) {
            let payload = billingContact;
            payload.contactPhone = billingContactPhone.e164;
            return new Promise((resolve, reject) => {
                this.$ajax.put('/rest/sellsy-account-manager/corporation/' + corporation + '/billing-contact', billingContact, {}, (response) => {
                    if (response.error) {
                        throw response;
                    }
                    resolve(response)
                });
            });
        },
        recordBillingAddress(corporation, billingAddress) {
            return new Promise((resolve, reject) => {
                 this.$ajax.put('/rest/sellsy-account-manager/corporation/' + corporation + '/billing-address', billingAddress, {}, (response) => {
                    if (response.error) {
                        throw response;
                    }
                    resolve(response)
                });
            });
        },
        acceptTerms(type, version) {
            return new Promise((resolve, reject) => {
                    this.$ajax.put(`/rest/terms/` + type, {}, {version: version}, (response) => {
                    if (response.error) {
                        throw response;
                    }
                    resolve(response)
                });
            })
        },
        recordStripeToken(corporation, token) {
            return new Promise((resolve, reject) => {
                this.$ajax.put('/rest/sellsy-account-manager/corporation/' + corporation + '/stripe-token', {}, {stripeToken: token}, (response) => {
                    if (response.error) {
                       reject(response);
                    }
                    resolve(response)
                    
                });
            });
        },
        recordBillingSettings(corporation, settings) {
            return new Promise((resolve, reject) => {
                this.$ajax.put('/rest/sellsy-account-manager/corporation/' + corporation + '/billing-settings', {}, settings, (response) => {
                    if (response.error) {
                        throw response;
                    }
                    resolve(response)
                });
            });
        },
        recordCustomerSettings(corporation, settings) {
            return new Promise((resolve, reject) => {
                this.$ajax.put('/rest/sellsy-account-manager/corporation/' + corporation + '/settings', {}, settings, (response) => {
                    if (response.error) {
                        throw response;
                    }
                    resolve(response)
                });
            });
        },
        updateAvailableStaffNumber(corporation, availableStaffNumber) {
            return new Promise((resolve, reject) => {
                this.$ajax.put('/rest/corporation/' + corporation + '/available-staff-number', {}, { availableStaffNumber: availableStaffNumber }, (response) => {
                    if (response.error) {
                        throw response;
                    }
                    resolve(response)
                });
            });
        },
        // POST
        recordCart(corporation, payload, asDraft) {
            return new Promise((resolve, reject) => {
                this.$ajax.post('/rest/sellsy-account-manager/corporation/' + corporation + '/cart', { draft: !!asDraft || null }, payload, (response) => {
                    if (response.error) reject(response);
                    resolve(response)
                });
            });
        },
        createCartPaymentIntent(cart) {
            return new Promise((resolve, reject) => {
                this.$ajax.post('/rest/sellsy-account-manager/cart/' + cart + '/payment-intents', {}, {}, (response) => {
                    if (response.error) reject(response);
                    resolve(response)
                });
            });
        },
        checkPaymentForCart(cart) {
            return new Promise((resolve, reject) => {
                this.$ajax.post('/rest/sellsy-account-manager/cart/' + cart + '/check-payment', {}, {}, (response) => {
                    if (response.error) reject(response);
                    resolve(response)
                });
            });
        },

        // PATCH
        cancelCart(cartId) {
            return new Promise((resolve, reject) => {
                this.$ajax.patch('/rest/sellsy-account-manager/cart/' + cartId + '/cancel', {}, {}, (response) => {
                    if (response.error) reject(response);
                    resolve(response)
                });
            });
        },
        markCartAsPaid(cartId) {
            return new Promise((resolve, reject) => {
                this.$ajax.patch('/rest/sellsy-account-manager/cart/' + cartId + '/mark-as-paid', {}, {}, (response) => {
                    if (response.error) reject(response);
                    resolve(response)
                });
            });
        },
        markCartAsDraft(cartId) {
            return new Promise((resolve, reject) => {
                this.$ajax.patch('/rest/sellsy-account-manager/cart/' + cartId + '/mark-as-draft', {}, {}, (response) => {
                    if (response.error) reject(response);
                    resolve(response)
                });
            });
        },

        getCountries() {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/countries`, {}, (response) => {
                    resolve(Object.values(response.countries))
                })
            })
        },

        getBillingLocales() {
            return new Promise((resolve, reject) => {
                resolve([
                    { code: "FR", name: this.$l10n.__('Français') },
                    { code: "EN", name: this.$l10n.__('Anglais') },
                ])
            })
        },
        
        captureAddress(address) {
            if (address.type && address.type == "noAlgolia"){
                this.billingAddressTmp.line1 = address.value;
            } else{
                this.billingAddressTmp.line1 = address.name;
                this.billingAddressTmp.line2 = '';
                this.billingAddressTmp.postalCode = address.postcode;
                this.billingAddressTmp.city = address.city;
                this.billingAddressTmp.country = undefined !== address.countryCode ? address.countryCode.toUpperCase() : null;
                this.billingAddressTmp.state = address.administrative;
            }
        },
        isAddressValid(address) {
            // Define required properties
            let requiredFields = ["line1", "postalCode", "city", "country"];
            // Define default value for required properties
            let defaultValues = {};
            requiredFields.forEach(field => defaultValues[field] = null);
            // Merge address + defaultValues
            let addressProperties = Object.values(_.pick(_.extend(defaultValues, { ...address }), ...requiredFields));
            // .filter(c => c) allow to "unset" empty value
            return addressProperties.filter(c => c).length === addressProperties.length;
        },
        isContactValid(contact, phone) {
            // Define required properties
            let requiredFields = ["contactName", "contactFirstName", "contactEmail","locale"];
            // Define default value for required properties
            let defaultValues = {};
            requiredFields.forEach(field => defaultValues[field] = null);
            
            if (phone === undefined) { phone = { e164: contact.contactPhone }; }
            // Merge contact + defaultValues
            let contactProperties = Object.values(_.pick(_.extend(defaultValues, { ...contact }), ...requiredFields));
            // .filter(c => c) allow to "unset" empty value
            return contactProperties.filter(c => c).length === contactProperties.length && !!phone.e164;
        },
        isCustomMailValid() {
            let state = false;
            this.$refs.billingCustomMail.validate((valid) => {
                state = valid;
            });
            return state;
        },
        getCreditNote(corporation) {
            return new Promise((resolve, reject) => {
                this.$ajax.get('/rest/sellsy-account-manager/corporation/' + corporation + '/compute-credit-note', {}, (response) => {
                    if (response.error) {
                        reject(response);
                    }
                    resolve(response);
                });
            });
        },
    },
}
